"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkedPromo = void 0;
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _clsx = _interopRequireDefault(require("clsx"));
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./LinkedPromo.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LinkedPromo = props => {
  const {
    name,
    activeDateTo,
    description,
    onClick
  } = props;
  const [collapsed, setCollapsed] = React.useState(true);
  const toggleCollapse = React.useCallback(() => {
    setCollapsed(prev => !prev);
    if (collapsed) {
      onClick();
    }
  }, [collapsed, onClick]);
  return /*#__PURE__*/React.createElement("div", {
    className: style['linked-promo'],
    onClick: toggleCollapse,
    "data-testid": "LinkedPromo"
  }, /*#__PURE__*/React.createElement("div", {
    className: style['wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['wrapper-inner']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['content']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, name), /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "text-secondary-default"
  }, activeDateTo)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement("div", {
    className: style['arrow']
  }, collapsed ? /*#__PURE__*/React.createElement(_icons.IconActionChevronDown16, {
    color: "icon-secondary-default"
  }) : /*#__PURE__*/React.createElement(_icons.IconActionChevronUp16, {
    color: "icon-secondary-default"
  }))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true,
    desktop: true
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, {
    color: "text-positive-default"
  }, collapsed ? 'Подробнее' : 'Свернуть'))), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['description'], collapsed && style['collapsed']),
    "data-testid": "LinkedPromoDescription"
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, null, description))));
};
exports.LinkedPromo = LinkedPromo;